import React from 'react';
import './sidebar.css';

const Sidebar = ({ active = 'Dashboard' }) => {
  const menuItems = [
    'Dashboard',
    'Events',
    'Bookings',
    'Categories',
    'Users',
    'Support Messages',
    'Feedback & Reviews',
    'Landing Page Content',
    'Navigation Menu',
    'Settings',
  ];

  const routes = {
    Dashboard: '/home',
    Events: '/events',
    Bookings: '/bookings',
    Categories: '/categories',
    Users: '/users',
    'Support Messages': '/support-messages',
    'Feedback & Reviews': '/feedback',
    'Landing Page Content': '/landing-content',
    'Navigation Menu': '/navigation-menu',
    Settings: '/settings',
  };

  const goToPage = (item) => {
    window.location.href = routes[item];
  };

  const logout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    window.location.href = '/';
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <h1>Spine Admin</h1>
        <p>Literary Events Platform</p>
      </div>

      <nav className="sidebar-menu">
        {menuItems.map((item) => (
          <button
            key={item}
            onClick={() => goToPage(item)}
            className={`sidebar-item ${active === item ? 'active' : ''}`}
          >
            {item}
          </button>
        ))}
      </nav>

      <button className="logout-btn" onClick={logout}>
        <span>↪</span>
        Logout
      </button>
    </aside>
  );
};

export default Sidebar;